// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wc_a bhp_b"};